import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SaleService } from 'src/app/service/sale.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { Sale } from '../sale/sale';
import { SaleDialogImprimirComponent } from '../sale-dialog-imprimir/sale-dialog-imprimir.component';
import { NotaFiscalDialogComponent } from '../nota-fiscal-dialog/nota-fiscal-dialog.component';


@Component({
  templateUrl: './sales-list.component.html',
  styleUrls: ['./sales-list.component.scss']
})
export class SalesListComponent implements OnInit {

  sales: Sale[] = [];
  ordemColunasTabela = ['id', 'cliente','amount', 'amountPaid', 'difference', 'payment','createdAt', 'excluir', 'detalhe','nota'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100]; // [10,20,30] quantidade de item por página
  mensagemErros: String[] = []; //array de strings dos erros retornados do backend
  tipoFiltro: any;
  parametroConsulta: any;
  tipoFiltros: String[] = ['Periodo'];
  dataInicio: any;
  dataFim: any;

  constructor(
    private saleService: SaleService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.listSales(this.pagina, this.tamanho);
    this.tipoFiltro = "Periodo";
  }

  listSales(pagina: number, tamanho: number) {
    this.saleService.list(pagina, tamanho).subscribe((response) => {
      this.sales = response.content;
      this.totalElementos = response.totalElements;
      this.pagina = response.number;
    });
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      // se clicar em ok chama evento de excluir
      if (result) {
        this.excluir(id);
      }
    });
  }

  openDialogDetalhe(sale: Sale): void {    
      //abrir dialog
      let dialogRef = this.dialog.open(SaleDialogImprimirComponent, {
        width: '700px',
        data: {
          sale: sale
        }
      });
      //confirmar venda
      dialogRef.afterClosed().subscribe(result => {
      });
  }

  private excluir(id: number) {
    this.saleService.delete(id).subscribe((response) => {
      this.ngOnInit();
      this.mensagemErros = [];
      // exibir mensagem snackbar
      this.snackBar.open('Venda excluida com sucesso!', 'Sucesso', {
        duration: 2000
      })
    }, errorResponse => {
      // exibe mensagem de erro da api
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    })
  }

  //chamar a paginação
  paginar(event: PageEvent) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar();
  }

  consultar(){ 
    this.dataInicio = document.getElementById('dataInicio');
    this.dataFim = document.getElementById('dataFim');    
    this.saleService.findSale(this.pagina, this.tamanho,this.dataInicio.value,this.dataFim.value).subscribe((response) => {
      this.sales = response.content; // pegar o conteudo do pag
      this.totalElementos = response.totalElements;// pegar o total de elementos
      this.pagina = response.number;// pegar o numero de paginas
    });
  }

  openDialogNotaFiscal(id: number) {
    const dialogRef = this.dialog.open(NotaFiscalDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.emitirNotaFiscal(id);
      }
    });
  }

  emitirNotaFiscal(id: number) {
    this.mostrarLoading();
    this.saleService.emitirNotaFiscal(id).subscribe((response: any) => {
      const file = new Blob([response.body],{});
         const blob = window.URL.createObjectURL(file);
         const link = document.createElement('a');
         link.href = blob;
         link.download = 'notaFiscal.pdf';
         link.click();
         window.URL.revokeObjectURL(blob);
         link.remove();
         this.fecharLoading();
       },
       error => {
        this.snackBar.open('Ocorreu um erro ao gerar a nota Fiscal', 'Erro', {
          duration: 2000
        })
         this.fecharLoading();
       })
  }

  public mostrarLoading() {
    let load = document.getElementById('preloader');
    load?.setAttribute("style", "display:block;");
  }
  public fecharLoading() {
    let load = document.getElementById('preloader');
    load?.setAttribute("style", "display:none;");
  }

}
